<template>
  <div class="nav-bar mini-width" :style="{ background: background, height: height }">
    <div class="nav-bar-box w-1400">
      <router-link
          @click="activeIndex = index"
          :class="[
          'router-link',
          'nav-item',
          index === activeIndex ? 'nav-item-active' : '',
        ]"
          :style="{ height: height }"
          v-for="(item, index) in tarBarList"
          :key="index"
          :to="item.path"
      >{{ item.name }}
      </router-link
      >
      <!-- <div class="more-box nav-item" @click="showMoreBoxfun">
        <i class="el-icon-caret-bottom"></i>
        <div class="more-box-dropdown" v-if="showMoreBox">
          <div class="more-box-dropdown-item">
            <router-link class="more-box-dropdown-item-link" to="/technology"
              >技术项目交易
            </router-link>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "navicat",
  props: {
    current: {
      type: Number,
      default: 0,
    },
    background: {
      type: String,
      default: "#ffffff",
    },
    height: {
      type: String,
      default: "60px",
    },
  },
  data() {
    return {
      showMoreBox: false,
      activeIndex: 0,
      tarBarList: [
        {
          name: "首页",
          path: "/",
        },
        {
          name: "试剂商城",
          path: "/shop",
        },
        {
          name: "原料采购专区",
          path: "/purchase",
        },
        {
          name: "原料供应专区",
          path: "/supply",
        },
        {
          name: "化工资讯",
          path: "/ruitian-news",
        },
        {
          name: "关于我们",
          path: "/about-us",
        },
        {
          name: "行业工具",
          path: "/industry-tools",
        },
        {
          name: "来料加工",
          path: "/project-transaction",
        },
        {
          name: "技术项目交易",
          path: "/technology",
        },
      ],
    };
  },
  mounted() {
    this.activeIndex = this.current;
  },
  methods: {
    showMoreBoxfun() {
      this.showMoreBox = !this.showMoreBox;
    },

  },
};
</script>
<style lang="scss" scoped>
.nav-bar {
  // height: 95px;
  // background: #0f121a;
  padding: 0;
  margin: 0;

  .nav-bar-box {
    display: flex;
    gap: 50px;

    .nav-item {
      color: #333333;
      padding: 20px 0 28px;
      box-sizing: border-box;
      border-bottom: 4px solid transparent;
    }

    .nav-item-active {
      border-bottom: 4px solid #3860f4 !important;
    }
  }
}

.more-box-dropdown {
  background: #fff;
  line-height: 50px;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5);

  .more-box-dropdown-item {
    padding: 0 20px;
    margin-top: 10px;

    .more-box-dropdown-item-link {
      text-decoration: none;
      color: #333;

      &:hover {
        color: #3860f4;
      }
    }

  }
}
</style>
